var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateDelegatePackage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4232 12.24C10.6941 12.42 11.0554 12.42 11.3263 12.24L15.8421 9.63V9.9C16.4743 9.9 17.1065 9.99 17.6484 10.26V8.64L18.5515 8.1C19.0031 7.83 19.0934 7.29 18.9128 6.84L17.5581 4.59C17.4677 4.41 17.3774 4.23 17.1968 4.14L10.0619 0.18C9.8813 0.09 9.70067 0 9.52004 0C9.33941 0 9.15878 0.09 8.97815 0.18L1.9336 4.14C1.75297 4.23 1.57234 4.32 1.48202 4.5L0.127302 6.84C-0.143642 7.29 0.0369876 7.83 0.488561 8.1C0.759506 8.28 1.12076 8.28 1.39171 8.1V13.05C1.39171 13.41 1.57234 13.68 1.84328 13.86L8.97815 17.82C9.15878 17.91 9.33941 18 9.52004 18C9.70067 18 9.8813 17.91 10.0619 17.82L10.8748 17.37C10.6038 16.83 10.5135 16.2 10.4232 15.57M8.61689 15.57L3.198 12.51V6.48L8.61689 9.54V15.57ZM16.8355 6.93L11.1457 10.17L10.6038 9.27L16.2937 6.03L16.8355 6.93ZM9.52004 7.92V1.98L14.9389 4.95L9.52004 7.92Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5C13.792 11.5 12 13.292 12 15.5C12 17.708 13.792 19.5 16 19.5C18.208 19.5 20 17.708 20 15.5C20 13.292 18.208 11.5 16 11.5ZM18.4 15.9H16.4V17.9H15.6V15.9H13.6V15.1H15.6V13.1H16.4V15.1H18.4V15.9Z",
    fill: "#448870"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateDelegatePackage2);
export default __webpack_public_path__ + "static/media/create-delegate-package_2.3cef7ea3fc04865f92a7f3cfdf4d62b9.svg";
export { ForwardRef as ReactComponent };